import axios from 'axios';
import properties from '../../properties';
import {
  BuildScenarioRowResult,
  TableType,
} from '../../../pages/FinancialForensicsPage/FinancialForensics.types';
import { FixedCostFeeCalculation } from '../../../pages/FinancialForensicsPage/types/FixedCost.types';

export const addReconciliation = async (
  egNid: string,
  reconciliationInfo: { name: string; notes?: string },
  createdBy: string,
  planStartDate: string,
  planEndDate: string,
  totalFixedCost: number,
  totalVariableCost: number,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.addReconciliation,
      {
        egNid,
        reconciliationName: reconciliationInfo?.name?.trim(),
        notes: reconciliationInfo?.notes?.trim(),
        createdBy,
        planStartDate,
        planEndDate,
        totalFixedCost,
        totalVariableCost,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        handleOpenSnackBar(
          'Reconciliation added successfully',
          'success',
          1000,
        );
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const fetchReconciliations = async (
  egNid: string,
  planStartDate?: string,
  planEndDate?: string,
  pageNumber?: number,
  pageSize?: number,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.getReconciliations,
      {
        egNid,
        pageNumber,
        pageSize,
        planStartDate,
        planEndDate,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const deleteReconciliation = async (
  id: string,
  handleOpenSnackBar?: any,
) => {
  try {
    const response = await axios.delete(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        `/reconciliations/${id}`,
    );
    handleOpenSnackBar('Reconciliation deleted successfully', 'success', 2000);
    return response;
  } catch (error: any) {
    handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    return null;
  }
};

export const duplicateReconciliation = async (
  id: string,
  handleOpenSnackBar?: any,
) => {
  try {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        '/duplicate-reconciliation',
      {
        id,
      },
    );
    handleOpenSnackBar(
      'Reconciliation duplicated successfully',
      'success',
      2000,
    );
    return response;
  } catch (error: any) {
    handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    return null;
  }
};

export const addBuildReconciliation = async (
  egNid: string,
  reconciliationId: string,
  startDate: string,
  endDate: string,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.addBuildReconciliation,
      {
        egNid,
        reconciliationId,
        startDate,
        endDate,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.message, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const fetchAddReconciliations = async (
  egNid: string,
  reconciliationId: string,
  startDate: string,
  endDate: string,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.getAddReconciliation,
      {
        egNid,
        reconciliationId,
        startDate,
        endDate,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      return null;
    });
};

export const updateAddReconciliation = async (
  egNid: string,
  reconciliationId: string,
  vendorId: string,
  serviceId: string,
  feeCalculation?: FixedCostFeeCalculation,
  totalFee?: number,
  type?: BuildScenarioRowResult,
  tableType?: TableType,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.updateAddReconciliation,
      {
        egNid,
        reconciliationId,
        vendorId,
        serviceId,
        feeCalculation,
        totalFee,
        type,
        tableType,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.message, 'error', 6000);
      return null;
    });
};

export const uploadReconciliationFiles = async (
  egNid: string,
  reconciliationId: string,
  startDate: string,
  endDate: string,
  userId: string,
  files: File[],
) => {
  const formData = new FormData();
  formData.append('egNid', egNid);
  formData.append('reconciliationId', reconciliationId);
  formData.append('startDate', startDate);
  formData.append('endDate', endDate);
  formData.append('userId', userId);

  if (files && Array.isArray(files)) {
    files.forEach((file: File) => {
      formData.append('files', file);
    });
  }

  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.uploadReconciliationFiles,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};
